// Load the App, routes and components for the Website.
import {App} from './app'

/**
 * Website App class.
 * This is here in case we want to have some specific app logic
 * for the website over the CRM.
 */
class WebsiteApp extends App {

}

export {
  WebsiteApp
}
